export default __webpack_public_path__ + "src/assets/Pubmatic_Logo.jpg";